var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-logs-icon lucide-logs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12h1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19h1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5h8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12h8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19h8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogs);
export default __webpack_public_path__ + "static/media/logs.3d23b13d696022a78825a3b111cb7465.svg";
export { ForwardRef as ReactComponent };